import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
    button: {
        color: "white",
        borderRadius: "0px",
        height: 60,
        // Fixed width so every branch CTA matches (EN "Select" / EL "Επιλογή")
        width: 160,
        minWidth: 160,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background-color 0.3s ease-in-out",
        "@media (max-width: 799px)": {
            width: "100%",
            minWidth: "100%",
        },
    },
    text: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "center",
    },
});

export default styles;
